import { Range } from 'slate';
import { findNode } from '../../core/queries/findNode.mjs';

/**
 * Check if the selection is collapsed and contained within a node of a given type.
 */

function isCollapsedSelectionWithinNode(editor, {
  type,
  element
}) {
  const {
    selection
  } = editor;
  if (!selection) {
    return false;
  }
  if (!Range.isCollapsed(selection)) {
    return false;
  }
  const match = findNode(editor, {
    at: selection,
    match: {
      type
    }
  });
  return match ? match[0] === element : false;
}

export { isCollapsedSelectionWithinNode };
